import { oidcDiscoverySchema, type OidcDiscovery } from './types';

const WELL_KNOWN = '/.well-known/openid-configuration';

export interface DiscoverOptions {
  fetch?: typeof globalThis.fetch;
  signal?: AbortSignal;
}

/**
 * Fetch and validate the OIDC discovery document for an issuer URL.
 * Throws if the response is missing required endpoints.
 */
export async function discoverIssuer(
  issuer: string,
  options: DiscoverOptions = {},
): Promise<OidcDiscovery> {
  const fetchImpl = options.fetch ?? globalThis.fetch.bind(globalThis);
  const url = `${issuer.replace(/\/+$/, '')}${WELL_KNOWN}`;
  const response = await fetchImpl(url, {
    headers: { Accept: 'application/json' },
    signal: options.signal,
  });
  if (!response.ok) {
    throw new Error(`OIDC discovery failed: ${response.status} ${response.statusText} (${url})`);
  }
  const raw = (await response.json()) as unknown;
  const parsed = oidcDiscoverySchema.safeParse(raw);
  if (!parsed.success) {
    throw new Error(`OIDC discovery document invalid: ${JSON.stringify(parsed.error.issues)}`);
  }
  return parsed.data;
}
